import React from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { Badge } from 'react-bootstrap';
import './WorkflowBPMNViewer.css';

interface StepData extends Record<string, unknown> {
  label: string;
  step: any;
  groups?: any[];
  customFields?: any[];
  stepConfigs?: any[];
  status?: string;
  isCurrent?: boolean;
  isCompleted?: boolean;
  isPending?: boolean;
  description?: string;
  isStart?: boolean;
  isEnd?: boolean;
}

const BPMNNode = ({ data, selected }: NodeProps) => {
  const stepData = data as unknown as StepData;
  const { label, isStart, isEnd, isCurrent, isCompleted, isPending, status, description } = stepData || {};

  if (isStart) {
    return (
      <div className={`bpmn-node bpmn-start-event ${selected ? 'selected' : ''}`}>
        <Handle type="source" position={Position.Right} />
        <div className="bpmn-start-icon">
          <svg width="60" height="60" viewBox="0 0 60 60">
            <circle cx="30" cy="30" r="25" fill="#28a745" stroke="#1e7e34" strokeWidth="3" />
            <circle cx="30" cy="30" r="15" fill="white" />
          </svg>
        </div>
        <div className="bpmn-node-label">Início</div>
      </div>
    );
  }

  if (isEnd) {
    return (
      <div className={`bpmn-node bpmn-end-event ${selected ? 'selected' : ''}`}>
        <Handle type="target" position={Position.Left} />
        <div className="bpmn-end-icon">
          <svg width="60" height="60" viewBox="0 0 60 60">
            <circle cx="30" cy="30" r="25" fill="#dc3545" stroke="#c82333" strokeWidth="3" />
            <circle cx="30" cy="30" r="15" fill="white" />
            <circle cx="30" cy="30" r="8" fill="#dc3545" />
          </svg>
        </div>
        <div className="bpmn-node-label">Fim</div>
      </div>
    );
  }

  // Gateway (diamante)
  if (stepData?.step?.previous_steps && stepData.step.previous_steps.length > 0) {
    const nodeColor = isCurrent 
      ? '#1d428a' 
      : isCompleted 
        ? '#198754' 
        : '#6c757d';
    
    return (
      <div className={`bpmn-node bpmn-gateway ${selected ? 'selected' : ''} ${isCurrent ? 'current' : ''} ${isCompleted ? 'completed' : ''} ${isPending ? 'pending' : ''}`}>
        <Handle type="target" position={Position.Left} />
        <Handle type="source" position={Position.Right} />
        <div className="bpmn-gateway-shape" style={{ borderColor: nodeColor }}>
          <svg width="100" height="100" viewBox="0 0 100 100">
            <polygon
              points="50,10 90,50 50,90 10,50"
              fill="white"
              stroke={nodeColor}
              strokeWidth="3"
            />
          </svg>
          <div className="bpmn-gateway-content">
            <div className="bpmn-node-title">{label}</div>
            {status && (
              <Badge bg={isCurrent ? 'primary' : isCompleted ? 'success' : 'secondary'} className="bpmn-status-badge">
                {status}
              </Badge>
            )}
          </div>
        </div>
      </div>
    );
  }

  // Atividade (retângulo arredondado)
  const nodeColor = isCurrent 
    ? '#1d428a' 
    : isCompleted 
      ? '#198754' 
      : '#6c757d';
  
  const nodeOpacity = isPending ? 0.6 : 1;

  return (
    <div 
      className={`bpmn-node bpmn-activity ${selected ? 'selected' : ''} ${isCurrent ? 'current' : ''} ${isCompleted ? 'completed' : ''} ${isPending ? 'pending' : ''}`}
      style={{ borderColor: nodeColor, opacity: nodeOpacity }}
    >
      <Handle type="target" position={Position.Left} />
      <Handle type="source" position={Position.Right} />
      
      <div className="bpmn-activity-content">
        <div className="bpmn-activity-header">
          <div className="bpmn-node-title">{label}</div>
          {isCurrent && (
            <div className="bpmn-current-indicator">
              <span className="bpmn-pulse-dot"></span>
            </div>
          )}
        </div>
        
        {status && (
          <Badge bg={isCurrent ? 'primary' : isCompleted ? 'success' : 'secondary'} className="bpmn-status-badge">
            {status}
          </Badge>
        )}
        
        {description && (
          <div className="bpmn-node-description">{description}</div>
        )}
        
        {isCompleted && (
          <div className="bpmn-completed-check">✓</div>
        )}
      </div>
    </div>
  );
};

export default BPMNNode;


